/**
 * Pickers do antd gerados para objetos `moment` (o antd usa dayjs por
 * padrão). Mantém a API idêntica à do DatePicker/TimePicker do antd v4,
 * evitando reescrever as telas que passam/recebem moment.
 *
 * Uso: import { DatePicker, TimePicker } from "components/Utils/momentPickers";
 */
import * as React from "react";
import generatePicker from "antd/es/date-picker/generatePicker";
import momentGenerateConfig from "@rc-component/picker/lib/generate/moment";

export const DatePicker = generatePicker(momentGenerateConfig);

export const TimePicker = React.forwardRef((props, ref) => (
  <DatePicker {...props} picker="time" ref={ref} />
));
TimePicker.displayName = "TimePicker";

export default DatePicker;
